<template>
  <div class="product-detail" v-loading="loading">
    <div class="detail-topbar">
      <button type="button" class="back-button" @click="backToList">
        <i class="el-icon-back"></i>
        <span>返回列表</span>
      </button>
      <span class="detail-mark">产品详情</span>
    </div>

    <section class="detail-overview">
      <div class="product-media">
        <span class="media-label">产品图片</span>
        <div class="media-stage">
          <el-image
            v-if="productImage"
            class="detail-image"
            fit="contain"
            :src="productImage"
            :preview-src-list="[productImage]"
          >
            <div slot="error" class="image-fallback">
              <img src="../assets/img/error.png" alt="产品图片加载失败" />
            </div>
          </el-image>
          <div v-else class="image-fallback">
            <img src="../assets/img/error.png" alt="暂无产品图片" />
          </div>
        </div>
        <div class="media-caption">
          <i class="el-icon-zoom-in"></i>
          <span>点击图片查看大图</span>
        </div>
      </div>

      <div class="product-summary">
        <span class="summary-eyebrow">产品说明</span>
        <h1>{{ newsIdList.name || "产品详情" }}</h1>
        <div class="summary-line"></div>

        <div class="summary-tags">
          <span><i class="el-icon-picture-outline"></i> 产品图片</span>
          <span><i class="el-icon-document"></i> 产品说明</span>
          <span><i class="el-icon-data-analysis"></i> 参数图片</span>
        </div>

        <div class="description-block">
          <div
            class="product-content"
            v-if="newsIdList.description"
            v-html="newsIdList.description"
          ></div>
          <p class="empty-copy" v-else>暂无产品说明</p>
        </div>
      </div>
    </section>

    <section class="parameter-section">
      <div class="section-heading">
        <h2>参数图片</h2>
      </div>

      <div class="parameter-frame" v-if="parameterImage">
        <el-image
          class="parameter-image"
          fit="contain"
          :src="parameterImage"
          :preview-src-list="[parameterImage]"
        >
          <div slot="error" class="image-fallback">
            <img src="../assets/img/error.png" alt="参数图片加载失败" />
          </div>
        </el-image>
        <div class="media-caption">
          <i class="el-icon-zoom-in"></i>
          <span>点击图片查看大图</span>
        </div>
      </div>

      <div class="parameter-empty" v-else>
        <i class="el-icon-document"></i>
        <span>暂无参数图片</span>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: "ProductsDetail",
  props: {
    id: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      loading: false,
      pid: 0,
      newsIdList: {}
    };
  },
  computed: {
    productImage() {
      return this.newsIdList.image ? this.imgserver + this.newsIdList.image : "";
    },
    parameterImage() {
      return this.newsIdList.parameterImg ? this.imgserver + this.newsIdList.parameterImg : "";
    }
  },
  watch: {
    id: {
      immediate: true,
      handler(newVal) {
        this.pid = newVal;
        this.loadData();
      }
    }
  },
  methods: {
    loadData() {
      if (!this.pid) return;
      this.loading = true;
      this.$http
        .get(`/Product/Products/${this.pid}`)
        .then(response => {
          this.newsIdList = response.result || {};
        })
        .catch(error => {
          window.console.log(error);
          this.newsIdList = {};
        })
        .finally(() => {
          this.loading = false;
        });
    },
    backToList() {
      this.$emit("backToList");
    }
  }
};
</script>

<style lang="scss" scoped>
.product-detail {
  width: 100%;
  color: #142235;
}

.detail-topbar {
  min-height: 42px;
  margin-bottom: 18px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
}

.back-button {
  min-height: 36px;
  padding: 0 14px;
  border: 1px solid rgba(44, 172, 226, 0.42);
  border-radius: 999px;
  display: inline-flex;
  align-items: center;
  gap: 7px;
  background: #f7fbfe;
  color: #075b94;
  font-family: inherit;
  font-size: 14px;
  font-weight: 700;
  cursor: pointer;
  transition: background 0.22s ease, border-color 0.22s ease, box-shadow 0.22s ease;
}

.back-button:hover {
  border-color: rgba(44, 172, 226, 0.72);
  background: #e9f8ff;
  box-shadow: 0 10px 22px rgba(21, 109, 168, 0.12);
}

.detail-mark,
.media-label,
.summary-eyebrow {
  color: #7d8fa3;
  font-size: 12px;
  font-weight: 800;
  letter-spacing: 0;
}

.detail-mark {
  min-height: 28px;
  padding: 0 10px;
  border-radius: 999px;
  display: inline-flex;
  align-items: center;
  background: #e9f8ff;
  color: #075b94;
}

.detail-overview {
  display: grid;
  grid-template-columns: minmax(280px, 420px) minmax(0, 1fr);
  gap: 30px;
  align-items: stretch;
}

.product-media,
.product-summary,
.parameter-section {
  border: 1px solid #e3edf5;
  border-radius: 8px;
  background: #fff;
  box-shadow: 0 12px 30px rgba(20, 34, 53, 0.06);
}

.product-media {
  padding: 20px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  background: linear-gradient(180deg, #f8fcff, #fff);
}

.media-label {
  margin-bottom: 12px;
}

.media-stage {
  min-height: 320px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f4f9fd;
  border-radius: 8px;
  overflow: hidden;
}

.detail-image {
  width: 100%;
  height: 320px;
}

.image-fallback {
  width: 100%;
  min-height: 240px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f3f8fc;
}

.image-fallback img {
  max-width: 180px;
  max-height: 140px;
  object-fit: contain;
}

.media-caption {
  min-height: 34px;
  margin-top: 12px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  color: #607286;
  font-size: 13px;
}

.media-caption i {
  color: #2cace2;
}

.product-summary {
  padding: 28px;
  box-sizing: border-box;
  min-width: 0;
}

.product-summary h1 {
  margin-top: 8px;
  color: #10243b;
  font-size: 30px;
  line-height: 1.28;
  font-weight: 800;
  letter-spacing: 0;
}

.summary-line {
  width: 48px;
  height: 3px;
  margin: 16px 0 18px;
  border-radius: 999px;
  background: linear-gradient(90deg, #156da8, #2cace2);
  box-shadow: 0 0 12px rgba(44, 172, 226, 0.35);
}

.summary-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-bottom: 20px;
}

.summary-tags span {
  min-height: 30px;
  padding: 0 10px;
  border-radius: 999px;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: #f3f9fd;
  color: #2b5f86;
  font-size: 13px;
  font-weight: 700;
}

.summary-tags i {
  color: #2cace2;
}

.description-block {
  padding: 18px 20px;
  border: 1px solid #e8f0f6;
  border-radius: 8px;
  background: #f9fcfe;
}

.product-content {
  color: #3f5167;
  font-size: 15px;
  line-height: 1.8;
  overflow-wrap: anywhere;
}

.product-content :deep(p) {
  margin: 0 0 10px;
}

.product-content :deep(p:last-child) {
  margin-bottom: 0;
}

.product-content :deep(img) {
  max-width: 100%;
  height: auto;
}

.product-content :deep(table) {
  width: 100%;
  border-collapse: collapse;
}

.product-content :deep(td),
.product-content :deep(th) {
  padding: 9px 10px;
  border: 1px solid #dbe8f1;
}

.empty-copy {
  color: #7d8fa3;
  font-size: 15px;
}

.parameter-section {
  margin-top: 24px;
  padding: 24px;
  box-sizing: border-box;
}

.section-heading {
  margin-bottom: 18px;
  padding-bottom: 16px;
  border-bottom: 1px solid #e3edf5;
}

.section-heading h2 {
  margin-top: 5px;
  color: #142235;
  font-size: 24px;
  line-height: 1.35;
}

.parameter-frame {
  padding: 18px;
  border-radius: 8px;
  background: #f4f9fd;
  text-align: center;
}

.parameter-image {
  width: 100%;
  min-height: 260px;
  max-height: 560px;
}

.parameter-empty {
  min-height: 180px;
  border: 1px dashed #cfe1ee;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 10px;
  color: #7d8fa3;
  background: #f8fcff;
}

.parameter-empty i {
  color: #b7c7d8;
  font-size: 34px;
}

@media (max-width: 1020px) {
  .detail-overview {
    grid-template-columns: 1fr;
  }

  .media-stage,
  .detail-image {
    min-height: 260px;
    height: 260px;
  }
}

@media (max-width: 560px) {
  .detail-topbar,
  .section-heading {
    align-items: flex-start;
    flex-direction: column;
  }

  .product-summary,
  .parameter-section {
    padding: 18px;
  }

  .product-summary h1 {
    font-size: 24px;
  }

  .description-block,
  .parameter-frame {
    padding: 14px;
  }
}
</style>
